import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import NotificationDatatable from "./components/NotificationDatatable";
import AlertDatatable from "./components/AlertDatatable";

const Notifications = () => {
  return (
    <>
      <div>
        <Sidebar />
      </div>

      <MainSection>
        <SectionHeader title="Notifications" />
        

        {/* Table structure for jQuery DataTable */}

        <DatatableSection>
          <NotificationDatatable />
        </DatatableSection>

        <hr className="my-8"></hr>

        {/* <SearchBar
          titleOne="Add Alerts"
          addClientPath="/notifications/add-alert"
          showEditButton={false} // Hide the Sort button
        /> */}

        {/* Table structure for jQuery DataTable */}

        <DatatableSection>
          <AlertDatatable />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default Notifications;
